/**
 * The platform's possible overlaps (Feature 74 D11, Feature 77 D28): every
 * linkage template, as an automation, with the others it shares a source and
 * a target with. Read from the list the console already caches.
 */
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { listLinkageTemplates } from '@optum/api-client/endpoints/linkage-templates';

import { qk } from '../../lib/query-keys.js';
import { fromLinkageTemplate, overlapsOf, type Automation } from './overlaps.js';

/** The overlaps of one template, by its key; none while the list loads. */
export function usePlatformOverlaps(): (key: string) => Automation[] {
  const linkages = useQuery({ queryKey: qk.linkageTemplates(), queryFn: listLinkageTemplates });
  const found = useMemo(
    () => overlapsOf((linkages.data ?? []).map(fromLinkageTemplate)),
    [linkages.data],
  );
  return (key) => found.get(key) ?? [];
}
